

const ScroolWindowTop=(id,Data)=>{
    
        // scroll to top
        window.scroll(0, 0);

};


export default ScroolWindowTop;